import { RatingCheckListFilter } from '@app/modules/table/classes/column-filters/check-list/rating-check-list-filter.class';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { InteractableColumn } from '@app/modules/table/interfaces/interactable-column.interface';
import { Applicant } from '@models/recruiting/applicant.model';

export class RatingColumn extends Column implements InteractableColumn {
    title = 'applicant-tracker.applicants-table.rating';
    property = 'rating';
    sortField = 'rating';
    sortable = true;
    type: CellDisplay = CellDisplay.rating;
    filter = new RatingCheckListFilter('rating', [
        { label: '5', value: '5' },
        { label: '4', value: '4' },
        { label: '3', value: '3' },
        { label: '2', value: '2' },
        { label: '1', value: '1' },
    ]);

    onRowChange(applicant: Applicant): void {
        const originalRating = applicant.getOriginalAttribute('rating');

        if (originalRating === applicant.rating) {
            applicant.rating = 0;
        }

        applicant.param('company', applicant.companyId).save();
    }

    getBindProperty(_applicant: Applicant): string {
        return 'rating';
    }
}
